import { css, html, LitElement } from "lit";
import { customElement, property } from "lit/decorators";
import {
  normalizeStyles,
  containerStyles,
  typographyStyles,
} from "@webs/components-library/theming";
import {ifDefined} from 'lit/directives/if-defined.js';

@customElement("webs-site-simple-navigation")
export class SiteSimpleNavigation extends LitElement {
  static styles = [
    normalizeStyles,
    containerStyles,
    typographyStyles,
    css`
      :root {
        --default-paragraph-size: .7rem;
        --default-link-font-size: .7rem;
        --default-link-color: var(--color-base);
      }

      .m-site-simple-navigation {
        background: var(--color-light-grey);
        padding: 1rem 0;
      }

      .m-site-simple-navigation--scrolled {
        left: 0;
        position: fixed;
        top: 0;
        width: 100%;
        z-index: 100;
      }

      .m-site-simple-navigation__title {
        align-items: center;
        display: flex;
        margin-bottom: .5rem;
      }

      .m-site-simple-navigation__title p {
        margin: 0;
        transform: translateY(2px);
      }

      .m-site-simple-navigation__title img {
        height: 30px;
        object-fit: contain;
        width: 0;
      }

      .m-site-simple-navigation--scrolled .m-site-simple-navigation__title img {
        margin-right: .8rem;
        width: 30px;
      }

      .m-site-simple-navigation .container {
        align-items: center;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-bottom: -.5rem;
      }

      .m-site-simple-navigation__actions {
        margin: 0 -.5rem;
      }

      .m-site-simple-navigation__actions ::slotted(a) {
        display: inline-block;
        margin: 0 .5rem .5rem;
        font-size: 0.7rem !important;
        font-family: var(--font-family-alternative) !important;
        font-weight: var(--font-weight-semibold) !important;
        color: var(--color-grey) !important;
        text-decoration: none;
        line-height: 1.3rem !important;
      }

      .m-site-simple-navigation__actions ::slotted(a:hover) {
        color: var(--color-primary)!important;
      }

      .m-site-simple-navigation ::slotted(.main-link) {
        color: var(--color-dark-grey) !important;
      }

      @media only screen and (min-width: 992px){
        :host {
          --default-paragraph-size: .9rem;
        }
      }

      @media only screen and (min-width: 1175px){
        .m-site-simple-navigation--scrolled {
          z-index: 999;
        }
      }
    `,
  ];

  @property()
  id: string;

  @property()
  title = 'Subscription management';

  @property()
  logo: string;

  connectedCallback() {
    super.connectedCallback();
    window.addEventListener('scroll', () => {
      const navigation = this.renderRoot.querySelector('.m-site-simple-navigation');
      if (navigation) {
        setTimeout(() => {
          if (window.pageYOffset > 50) {
            navigation.classList.add('m-site-simple-navigation--scrolled')
          } else {
            navigation.classList.remove('m-site-simple-navigation--scrolled')
          }
        }, 3000)

      }
    });
  }

  protected render(): unknown {
    return html`
      <section id="${ifDefined(this.id)}" class="m-site-simple-navigation">
        <div part="container" class="container">
          <div class="m-site-simple-navigation__title">
            <img src="${this.logo}" alt="Logo" loading="lazy" width="30"/>
            <p>${this.title}</p>
          </div>

          <div class="m-site-simple-navigation__actions">
            <slot></slot>
          </div>
        </div>
      </section>
    `;
  }
}
